import React from 'react'
import Cross from '../../assets/notifications/cross.svg'
import Tick from '../../assets/notifications/tick.svg'
function GuestStatusPost(props) {    
   
  return (
    <div className='row' style={{alignItems:'center', justifyContent:'center'}}>
        <div className='img-container-post' style={{width:'20vw'}}>
            <img className='profile__pic--sm' src={process.env.PUBLIC_URL + '/icon.jpg'} />
        </div>
        <div style={{
            width:'25vw',
            }}>
            <p style={{
                width: '25vw',
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}>{props.data.username}</p>
        </div>
        <div style={{width:'20vw'}}>
            {props.invitationStatus == "NA" ? (
                <p>NA</p>
            ): (
                <>
                    {props.invitationStatus == "Yes" ? (
                        <img src={Tick} style={{width:20}}/>
                    ): (
                        <img src={Cross} style={{width:20}}/>
                    )}
                </>
            )}
            
        </div>
        <div style={{width:'20vw'}}>
            {props.invitationStatus == "NA" ? (
                <p>NA</p>
            ): (
                <>
                    {
                        props.playlistFlag ? (
                            <img src={Tick} style={{width:20}}/>
                        ): (
                            <img src={Cross} style={{width:20}}/>
                        )
                    }
                </>
            )}                        
        </div>
    </div>
  )
}

export default GuestStatusPost